import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
export class CardHistoryComponent {
  @Input()
  title!: string;
  @Input()
  text!: string;
  @Input()
  optional!: string;
}
